import React from 'react';
import { cn } from '@/lib/twUtils';

const tones = {
  /** Su fondo chiaro */
  light: 'bg-mist-soft border border-edge text-ink-strong',
  /** Su fondo bianco, contorno più marcato */
  outline: 'bg-white border border-edge text-ink-strong',
  /** Su banda navy */
  onDark: 'bg-white/8 border border-edge-on-dark text-white/82',
  /** Etichetta di categoria */
  tag: 'bg-mist-deep text-primary font-semibold tracking-[0.05em] uppercase',
  /** Etichetta arancione, per lo stato di una risposta */
  accent: 'bg-accent/10 text-accent-600 font-semibold tracking-[0.04em] uppercase',
} as const;

const sizes = {
  md: 'px-[0.9375rem] py-[0.5625rem] text-[0.84375rem]',
  sm: 'px-3 py-[0.4375rem] text-[0.78125rem]',
  xs: 'px-2.5 py-1 text-[0.6875rem]',
} as const;

export interface ChipProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: keyof typeof tones;
  size?: keyof typeof sizes;
  /** Pallino arancione a sinistra */
  dot?: boolean;
}

/** Pillola: fonti, certificazioni, tag, categorie. */
const Chip = ({
  tone = 'light',
  size = 'md',
  dot = false,
  className,
  children,
  ...props
}: ChipProps) => (
  <span
    className={cn(
      'inline-flex items-center gap-2 rounded-full whitespace-nowrap',
      tones[tone],
      sizes[size],
      className
    )}
    {...props}
  >
    {dot && <span aria-hidden className="h-1.5 w-1.5 shrink-0 rounded-full bg-accent" />}
    {children}
  </span>
);

export default Chip;
